<script>
import { mapActions, mapState } from 'vuex'
import ReportStatusDropdownItem from './ReportStatusDropdownItem.vue'

export default {
  components: {
    ReportStatusDropdownItem,
  },

  computed: {
    ...mapState({
      reportFiles: (state) => state.reports.reportFiles,
    }),
  },

  methods: {
    ...mapActions('reports', ['fetchReportFiles']),

    handleShow() {
      this.fetchReportFiles()
      this.$emit('removeBadge')
    },
  },
}
</script>

<template>
  <b-dropdown
    no-caret
    right
    class="reports-dropdown"
    boundary="scrollParent"
    variant="link"
    toggle-class="text-decoration-none"
    @show="handleShow()"
  >
    <template #button-content>
      <BaseIcon class="text-white" name="download" />
    </template>
    <div v-if="reportFiles.length === 0" class="text-center">
      No report is generated.
    </div>
    <div v-else>
      <div v-for="report in reportFiles" :key="report.name">
        <ReportStatusDropdownItem :report="report" />
      </div>
    </div>
  </b-dropdown>
</template>

<style lang="scss">
.reports-dropdown .dropdown-menu {
  min-width: 500px;
  max-height: 300px;
  overflow-y: auto;
}
</style>
